import { render, staticRenderFns } from "./edutalk-menu.vue?vue&type=template&id=5dba9903"
import script from "./edutalk-menu.vue?vue&type=script&lang=js"
export * from "./edutalk-menu.vue?vue&type=script&lang=js"
import style0 from "./edutalk-menu.vue?vue&type=style&index=0&id=5dba9903&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports